module.exports = "/_next/static/images/404_ed430f1f4081efaab16ac87f3deb42cf.png";